import { ButtonSize, ButtonVariant } from "@galaxy-io/dls/buttons/Button";
import Box from "@galaxy-io/dls/layout/Box";
import CodeBlock, { CodeBlockLanguage } from "@galaxy-io/dls/text/CodeBlock";
import Widget from "@galaxy-io/dls/widget/Widget";
import { useRouter } from "@/app/navigation";
import { Button } from "@/components/ui/button";
import type { RecordQuery } from "@/lib/record-queries";

export function RecordQueries({ queries }: { queries: RecordQuery[] }) {
  const router = useRouter();
  return (
    <>
      {queries.map((query) => (
        <Widget
          key={query.title}
          header={query.title}
          isFlush
          actions={
            <Button
              label="Open in console"
              size={ButtonSize.SMALL}
              variant={ButtonVariant.SECONDARY}
              onClick={() => router.push(`/query?sql=${encodeURIComponent(query.sql)}`)}
            />
          }
        >
          <Box maxHeight={240} overflow="auto">
            <CodeBlock
              content={query.sql}
              language={CodeBlockLanguage.SQL}
              label={`SQL: ${query.title}`}
              canCopy
            />
          </Box>
        </Widget>
      ))}
    </>
  );
}
